import { z } from 'zod';

export const PersonpermissionsScalarFieldEnumSchema = z.enum(['permissionId','personDepartmentId','cityId','personId','departmentId','classificationId','CETopicId','readOnly','noReports']);

export default PersonpermissionsScalarFieldEnumSchema;
